const SliderPlaceholder = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 298 168"
      width="100%"
      height="100%"
    >
      <g fill="none" fillRule="evenodd">
        <path fill="#EFEFEF" d="M0 0h304v235H0z" />
        <g fill="#DFDFDF" transform="translate(138 114)">
          <circle cx="1.5" cy="-14" r="3.5" />
          <circle cx="14.5" cy="-14" r="3.5" />
          <circle cx="27.5" cy="-14" r="3.5" />
        </g>
      </g>
    </svg>
  );
};

export default SliderPlaceholder;
